import { IconName, Icons, IconType } from './Icon.model';

type Loader = () => Promise<string>;

const svgModules = import.meta.glob('./*.svg', {
	query: '?raw',
	import: 'default',
});

const fallbackPath = `./${IconName.CROSS}.svg`;

const resolveSvgImporter = (iconName: string) => {
	const iconPath = `./${iconName}.svg`;
	return (svgModules[iconPath] ||
		svgModules[fallbackPath] ||
		(async () => '')) as () => Promise<string> | Promise<{ default: string }>;
};

const createLoader =
	(iconName: string): Loader =>
	async () => {
		try {
			const mod = await resolveSvgImporter(iconName)();
			return typeof mod === 'string' ? mod : mod?.default || '';
		} catch {
			return '';
		}
	};

const uniqueIconNames = Array.from(new Set(Object.values(Icons))) as IconType[];

export const iconLoaders = uniqueIconNames.reduce(
	(accumulator, iconName) => {
		accumulator[iconName] = createLoader(iconName);
		return accumulator;
	},
	{} as Record<IconType, Loader>
);
